<div class="w-full h-full flex justify-center items-center bg-white">
  <div class="max-w-5xl text-center gap-3 flex flex-col items-start">
    <div class="flex items-start gap-2">
      <img src="icons/bang.svg" alt="info" class="w-6 h-6" />
      <p class="w-full text-2xl text-[#1C3A87] font-bold">
        {{ getTitulo() }}
      </p>
    </div>

    <p class="text-xl text-[#586E89]">
      {{ getDescripcion() }}
    </p>
  </div>
</div>
